// 不同環境需要使用不同資源的變數都放在這裡管理

export type TServer = 'dev' | 'demo' | 'rel' | 'prod';
interface IConfig {
    COMMON?: {
        lightbox?: string; // 產品光箱
        multilang?: string; //多語系
        OrderValidation?: string //驗價API
        productItemDesc?: string; // 方案説明
    };
    THSR?: {
        init: string;
        detail: string;
        detail_oneWay?: string;
        stations: string;
        info: string;
        CheckThsrQty: string;
    };
    GDS: {
        list: string;
        detail: string;
        session: string;
        detailNextMonth?: string; // 本機開發模擬下個月用
        detailNextTwoMonth?: string; // 本機開發模擬下下個月用
        submitURL: string;
    };
    normal: {
        list: string;
        detail: string;
        detailNextMonth?: string; // 本機開發模擬下個月用
        detailNextTwoMonth?: string; // 本機開發模擬下下個月用
        submitURL: string;
    };
}

const envConfig: { [key: string]: IConfig } = {
    dev: { //本地
        COMMON: {
            lightbox: '/json/commonLightBoxData.json', // 產品光箱
            multilang: '/activity/', // 多語系Domain
            OrderValidation: '/activity/detail/BuyItemValidate', // 驗價API
            productItemDesc: '/activity/detail/ProductItemDesc' // 方案説明
        },
        THSR: {
            // U機區
            // init: '/activity/detail/ThsrDefaultItem',
            init: '/activity/detail/ThsrItemList',
            detail: '/activity/detail/GetThsrTrainNum',
            detail_oneWay: '/activity/detail/GetThsrTrainNum',
            stations: '/activity/detail/GetThsrTrainStation',
            info: '/activity/detail/GetThsrInfo',
            CheckThsrQty: '/activity/detail/CheckThsrQty',
            // 本機區
            // init: '/json/fakeTHSRInitData.json',
            // detail: '/json/fakeTHSRDetailData.json',
            // detail_oneWay: '/json/fakeTHSROneWayDetailData.json',
            // stations: '/json/fakeTHSRStation.json',
            // info: '/json/fakeTHSRInfoData.json',
        },
        GDS: {
            // U機區
            // list: '/activity/detail/ProductItemList', // 方案清單
            // detail: '/activity/detail/ProductItemDetail', // 方案細節
            list: '/activity/detail/GDSProductItemList', // 方案清單 TODO:之後融合刪除
            detail: '/activity/detail/GDSProductItemDetail', // 方案細節 TODO:之後融合刪除
            session: '/activity/detail/GDSProductItemSession', // 場次資訊 //TODO:下階段合併session
            // 本機區
            // list: '/json/fakeGDSListData.json', // 方案清單
            // detail: '/json/fakeGDSDetailData.json', // 方案細節
            // detailNextMonth: '/json/fakeGDSDetailNextMonthData.json', // 模擬下個月用 TODO:尚未更新成新版
            // detailNextTwoMonth: '/json/fakeGDSDetailNextTwoMonthData.json', // 模擬下下個月用 TODO:尚未更新成新版
            // session: '/json/fakeGDSSession.json', // 場次資訊 //TODO:下階段合併session
            submitURL: 'https://uactivity.liontravel.com/order/passenger',
        },
        normal: {
            // U機區
            list: '/activity/detail/ProductItemList', // 方案清單
            detail: '/activity/detail/ProductItemDetail', // 方案細節
            // TODO: session:  // 場次資訊
            // 本機區
            // list: '/json/fakeNormalListData.json', // 方案清單
            // list: '/json/fakeNormalListData_20D002.json', // 方案清單 20D002 (有高鐵產品)
            // detail: '/json/fakeNormalDetailData.json', //  方案細節
            detailNextMonth: '/json/fakeNormalDetailNextMonthData.json', // 模擬下個月用
            // detailNextTwoMonth: '/json/fakeNormalDetailNextTwoMonthData.json', // 模擬下下個月用 TODO:目前沒有這個
            // TODO: session:  // 場次資訊
            // detail: '/json/fakeNormalSoldData.json', // 補貨中範例資料
            // detail: '/json/fakeNormalAdvancedData.json', // 即將開賣範例資料
            submitURL: 'https://uactivity.liontravel.com/order/passenger',
        },
    },
    demo: { //DEMO
        GDS: {
            list: './_webassets/LightSpeed/SubSiteBundles/Activity-React/json/fakeGDSListData.json',
            detail: './_webassets/LightSpeed/SubSiteBundles/Activity-React/json/fakeGDSDetailData.json',
            session: './_webassets/LightSpeed/SubSiteBundles/Activity-React/json/fakeGDSSession.json',
            submitURL: '/order/passenger',
        },
        normal: {
            list: './_webassets/LightSpeed/SubSiteBundles/Activity-React/json/fakeNormalListData.json',
            detail: './_webassets/LightSpeed/SubSiteBundles/Activity-React/json/fakeNormalDetailData.json',
            submitURL: '/activity/order/passenger',
        },
    },
    rel: { //測試機
        COMMON: {
            lightbox: '/_Webassets/LightSpeed/subsitebundles/Activity-React/json/commonLightBoxData.json', // 產品光箱
            multilang: '/', // 多語系Domain
            OrderValidation: '/detail/BuyItemValidate', // 驗價API
            productItemDesc: '/detail/ProductItemDesc' // 方案説明
        },
        THSR: {
            // init: '/detail/ThsrDefaultItem',
            init: '/detail/ThsrItemList',
            detail: '/detail/GetThsrTrainNum',
            stations: '/detail/GetThsrTrainStation',
            info: '/detail/GetThsrInfo',
            CheckThsrQty: '/detail/CheckThsrQty',
        },
        GDS: {
            // list: '/detail/ProductItemList',
            // detail: '/detail/ProductItemDetail',
            list: '/detail/GDSProductItemList',
            detail: '/detail/GDSProductItemDetail',
            session: '/detail/GDSProductItemSession', //TODO:下階段合併session
            submitURL: 'https://uactivity.liontravel.com/order/passenger',
        },
        normal: {
            list: '/detail/ProductItemList',
            detail: '/detail/ProductItemDetail',
            submitURL: 'https://uactivity.liontravel.com/order/passenger',
        },
    },
    prod: { //正式機
        COMMON: {
            lightbox: '/_Webassets/LightSpeed/subsitebundles/Activity-React/json/commonLightBoxData.json', // 產品光箱
            multilang: '/', // 多語系Domain
            OrderValidation: '/detail/BuyItemValidate', // 驗價API
            productItemDesc: '/detail/ProductItemDesc' // 方案説明
        },
        THSR: {
            // init: '/detail/ThsrDefaultItem',
            init: '/detail/ThsrItemList',
            detail: '/detail/GetThsrTrainNum',
            stations: '/detail/GetThsrTrainStation',
            info: '/detail/GetThsrInfo',
            CheckThsrQty: '/detail/CheckThsrQty',
        },
        GDS: {
            // list: '/detail/ProductItemList',
            // detail: '/detail/ProductItemDetail',
            list: '/detail/GDSProductItemList',
            detail: '/detail/GDSProductItemDetail',
            session: '/detail/GDSProductItemSession', //TODO:下階段合併session
            submitURL: 'https://activity.liontravel.com/order/passenger',
        },
        normal: {
            list: '/detail/ProductItemList',
            detail: '/detail/ProductItemDetail',
            submitURL: 'https://activity.liontravel.com/order/passenger',
        },
    },
};

const getEnvConfig = (env?: string): IConfig => envConfig[process.env.SERVER];
export default getEnvConfig;
